import { type DesignSystemIcons } from "design-system/types";

import type { Sentiment } from "shared/types/mentions";

export interface SentimentOption {
  color: string;
  field: string;
  icon?: DesignSystemIcons;
  iconClass: string;
  inRange: (sentiment: Sentiment) => boolean;
  label: string;
  newIcon?: DesignSystemIcons;
  range: [number, number];
  value: number;
}

function inRange(this: SentimentOption, sentiment: Sentiment): boolean {
  if (sentiment === null) return false;

  const sentimentValue = Number(sentiment);

  return this.range[0] <= sentimentValue && sentimentValue < this.range[1];
}

const sentimentOptions: SentimentOption[] = [
  {
    color: "#49d067",
    field: "positive",
    icon: "positive",
    iconClass: "tw:text-green-400",
    inRange,
    label: "Positive",
    range: [0.6, 1.001],
    value: 1,
  },
  {
    color: "#78a6dd",
    field: "trending_positive",
    icon: "trending-positive",
    iconClass: "tw:text-blue-300",
    inRange,
    label: "Trending Positive",
    range: [0.2, 0.6],
    value: 0.5,
  },
  {
    color: "#3e475e",
    field: "balanced",
    icon: "balanced",
    iconClass: "tw:text-slate-600",
    inRange,
    label: "Balanced",
    range: [-0.2, 0.2],
    value: 0,
  },
  {
    color: "#f98d5d",
    field: "trending_negative",
    icon: "trending-negative",
    iconClass: "tw:text-orange-400",
    inRange,
    label: "Trending Negative",
    range: [-0.6, -0.2],
    value: -0.5,
  },
  {
    color: "#f95858",
    field: "negative",
    icon: "negative",
    iconClass: "tw:text-red-400",
    inRange,
    label: "Negative",
    range: [-1, -0.6],
    value: -1,
  },
];

export default sentimentOptions;
